export const en = {
  app: {
    name: 'Checkers',
  },
  seo: {
    title:
      'Russian Checkers (Shashki) & English Draughts Online — Free | BN-games',
    description:
      'Play checkers free in your browser — Russian shashki with flying kings, or English draughts. Against a bot, with a friend online, or on one device. No sign-up.',
    social:
      'Checkers in your browser — Russian shashki and English draughts. Play a friend online or a bot.',
    h1:
      'Checkers online — Russian shashki and English draughts',
    intro:
      'Checkers comes in many national variants. BN-games has two. In Russian checkers (shashki) men also capture backwards, kings fly along whole diagonals, and a man that reaches the far row in the middle of a capture keeps jumping as a king. English draughts — American checkers — has kings that move one square at a time and men that capture only forwards.\n\nPlay free in your browser against a bot, with a friend on the same device, or online by sending a room code.',
    rulesTitle:
      'Checkers Rules — Russian Shashki & English Draughts | BN-games',
    rulesDescription:
      'How to play checkers: the rules of Russian shashki (flying kings, backward captures) and English draughts, side by side — then play free online.',
    rulesH1:
      'Checkers rules: Russian shashki and English draughts',
    playCta:
      'Play checkers now',
  },
  a11y: {
    canvasLabel: 'Checkers board. Use arrow keys to move the focus across squares, Enter to select or commit a move.',
  },
  narration: {
    subjects: {
      you: 'You',
      opponent: 'Opponent',
      white: 'White',
      black: 'Black',
    },
    pieces: {
      man: 'man',
      king: 'king',
    },
    move: '{{subject}} moved {{piece}} from {{from}} to {{to}}.',
    captureOne: '{{subject}} captured a piece with {{piece}} from {{from}} and landed on {{to}}.',
    captureMany: '{{subject}} captured {{count}} pieces with {{piece}} from {{from}} ending on {{to}}.',
    promotionTail: 'Promoted to a king on {{to}}.',
    promotionEndsChain: 'The promotion ended the chain.',
    turn: "{{subject}}'s turn.",
    turnYou: 'Your turn.',
    gameOver: '{{subject}} wins.',
    gameOverYou: 'You win!',
    gameOverLoss: 'You lose.',
    gameOverDraw: 'Draw.',
    cursor: {
      empty: '{{square}}',
      ownMan: '{{square}}, your man',
      ownKing: '{{square}}, your king',
      oppMan: "{{square}}, opponent's man",
      oppKing: "{{square}}, opponent's king",
      whiteMan: '{{square}}, white man',
      whiteKing: '{{square}}, white king',
      blackMan: '{{square}}, black man',
      blackKing: '{{square}}, black king',
      validMove: '{{square}}, valid move',
      validCapture: '{{square}}, capture target',
    },
    selection: {
      man: 'Selected man on {{square}}.',
      king: 'Selected king on {{square}}.',
      deselect: 'Selection cleared.',
    },
    chainStep: 'Captured piece on {{cap}}. Landed on {{land}}. Chain continues.',
  },
  common: {
    back: '← Back',
    opponent: 'Opponent',
    white: 'White',
    black: 'Black',
    cycle: 'press Enter to cycle',
  },
  gameOverlay: {
    title: 'Game paused',
    openTooltip: 'Pause menu',
    settingsLabel: 'Settings',
    settingsBackLabel: '← Back',
    settingsViewTitle: 'Settings',
    restartLabel: 'Restart match',
    restartHintOnline: 'Online: all seats must agree. You get one proposal per match.',
    restartHintAlreadyProposed: "You've used your restart proposal this match.",
    restartHintPending: 'Waiting on the other seats…',
    returnToMenuLabel: 'Return to main menu',
    returnToMenuConfirmTitle: 'Leave this match and return to the menu?',
    returnToMenuConfirmYes: 'Yes, leave',
    returnToMenuConfirmNo: 'Stay',
    giveUpLabel: 'Give up',
    giveUpConfirmTitle: "Are you sure you're a coward?",
    giveUpConfirmYes: "Yes, I'm a coward",
    giveUpConfirmNo: "I'll fight on",
    settingsTabs: {
      gameplay: 'Gameplay',
      interface: 'Interface',
      audio: 'Audio',
    },
    discardConfirmTitle: 'Discard current game?',
    discardConfirmBody: 'Changing this setting will end the current game and start a new one.',
    discardConfirmYes: 'Discard and restart',
    discardConfirmNo: 'Cancel',
    close: 'Close',
  },
  auth: {
    signIn: 'Sign in',
    signOut: 'Sign out',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Complete your profile →',
    profile: 'Profile',
    backToLanding: '← BN-games',
  },
  social: {
    close: 'Close',
    invite: {
      message: '{{sender}} invites you to {{game}}',
      moreCount_one: '+{{count}} more invite',
      moreCount_few: '+{{count}} more invites',
      moreCount_many: '+{{count}} more invites',
      moreCount_other: '+{{count}} more invites',
      accept: 'Accept',
      decline: 'Decline',
      acceptAria: "Accept {{sender}}'s {{game}} invite",
      declineAria: "Decline {{sender}}'s {{game}} invite",
    },
    dock: {
      pillLabel: 'From {{sender}}',
      pillAria: 'Invite from {{sender}} to {{game}} — show',
      popoverLabel: 'Invite',
      close: 'Close invite',
      leaveGameTitle: 'Leave this game?',
      leaveGameBody: 'Accepting opens {{game}} and leaves the current game. In an online game your seat is held for a while, so you can come back.',
      leaveGameConfirm: 'Leave and join',
      leaveGameCancel: 'Stay',
    },
    friendPicker: {
      button: 'Invite friend',
      modalTitle: 'Invite a friend',
      loading: 'Loading friends…',
      signInPrompt: 'Sign in to invite a friend.',
      empty: "You don't have any friends yet.",
      findFriends: 'Find friends',
      invite: 'Invite',
      inviteAria: 'Invite {{name}}',
      invited: 'Invited',
      invitedAria: 'Invited {{name}}',
      notAccepting: "This player isn't accepting invites right now",
      retryIn: 'Try again in {{seconds}}s',
    },
    addOpponent: {
      buttonMany: 'Add friends…',
      modalTitle: 'Add friends',
      add: 'Add {{name}} as friend',
      added: 'Added',
      addedAria: 'Added {{name}} as friend',
    },
  },
  mainMenu: {
    quickStart: 'Quick Start',
    newGame: 'New Game',
    rules: 'Rules',
    settings: 'Settings',
    history: 'Games History',
    about: 'About',
  },
  preGame: {
    sideLabel: 'Your side',
    rematchPreview: "Rematch (you'll play {{side}})",
  },
  playMenu: {
    title: 'Play',
    vsAi: 'vs Bot',
    vsHuman: 'vs Human (local)',
    createOnline: 'Create online game',
    joinOnline: 'Join online game',
    gamesHistory: 'Games History',
    resume: 'Resume game',
    resumeOnline: 'Resume online ({{code}})',
    vsAiSession: 'vs Bot ({{difficulty}})',
    localMode: 'Local 2-player',
    onlineMode: 'vs {{opponent}}',
    justNow: 'just now',
    minutesAgo: '{{count}}m ago',
    hoursAgo: '{{count}}h ago',
    daysAgo: '{{count}}d ago',
    discardModal: {
      title: 'Discard active game?',
      body: 'Starting a new game will discard the current unfinished game. This cannot be undone.',
      keep: 'Keep game',
      discard: 'Discard',
    },
  },
  settings: {
    title: 'Settings',
    tabs: {
      gameplay: 'Gameplay',
      interface: 'Interface',
      audio: 'Audio',
    },
    rows: {
      playerName: 'Player name',
      sound: 'Sound',
      difficulty: 'Difficulty',
      defaultColor: 'Default color',
      theme: 'Theme',
      language: 'Language',
      showValidMoves: 'Show valid moves',
      variant: 'Variant',
      afkAssistEnabled: 'AFK move hint',
      afkRemindersEnabled: 'AFK reminder sound',
      turnStartSound: 'Your-turn sound',
      showAfkPingButton: 'Show ping button',
    },
    difficulties: {
      easy: 'Easy',
      normal: 'Normal',
      hard: 'Hard',
      expert: 'Expert',
    },
    colors: {
      white: 'White',
      black: 'Black',
      random: 'Random',
    },
    themes: {
      mahogany: 'Mahogany',
      persian: 'Persian',
      deco: 'Deco',
      monte: 'Monte',
    },
    languages: {
      en: 'English',
      ru: 'Русский',
    },
    variants: {
      russian: 'Soviet Shashki',
      english: 'English Draughts',
    },
    on: 'On',
    off: 'Off',
    namePrompt: 'Enter your name:',
  },
  about: {
    version: 'Version {{version}}',
    tech: 'TypeScript + Canvas',
  },
  rules: {
    screenTitle: 'Rules',
    russian: {
      title: 'Soviet Shashki',
      items: {
        setup: {
          title: 'Setup',
          body: 'Each player has 12 men on the dark squares of the three rows closest to them on an 8×8 board. White moves first.',
        },
        menMovement: {
          title: 'Men',
          body: 'A man moves one square diagonally forward to an empty dark square.',
        },
        menCaptures: {
          title: 'Man Captures',
          body: 'A man captures by jumping over an adjacent opponent — forward or backward — landing on the empty square just beyond. Captures are mandatory.',
        },
        kings: {
          title: 'Kings (Damka)',
          body: 'A man that reaches the opponent\'s back row is promoted to a king. Kings are flying — they slide any number of empty squares along a diagonal in either direction.',
        },
        kingCaptures: {
          title: 'King Captures',
          body: 'A king captures by sliding any number of empty squares along a diagonal, jumping a single opponent, and landing on any empty square beyond it.',
        },
        chain: {
          title: 'Chain Captures',
          body: 'If a capture is possible from the landing square, the chain continues in the same turn. The player chooses which legal chain to play — there is no maximum-pieces rule.',
        },
        midJumpPromotion: {
          title: 'Mid-jump Promotion',
          body: 'A man that lands on the king row mid-chain promotes immediately and continues the chain as a king.',
        },
        ending: {
          title: 'Ending',
          body: 'You win by capturing every opponent piece or by leaving them with no legal move. Draws occur on 15 consecutive king-only moves, threefold repetition, or insufficient material.',
        },
      },
    },
    english: {
      title: 'English Draughts',
      items: {
        setup: {
          title: 'Setup',
          body: 'Each player has 12 men on the dark squares of the three rows closest to them on an 8×8 board. Black moves first.',
        },
        menMovement: {
          title: 'Men',
          body: 'A man moves one square diagonally forward to an empty dark square.',
        },
        menCaptures: {
          title: 'Man Captures',
          body: 'A man captures only by jumping forward over an adjacent opponent, landing on the empty square just beyond. Captures are mandatory.',
        },
        kings: {
          title: 'Kings',
          body: 'A man that reaches the opponent\'s back row is promoted to a king. Kings move one square diagonally in either direction — forward or backward.',
        },
        kingCaptures: {
          title: 'King Captures',
          body: 'A king captures by jumping over an adjacent opponent — forward or backward — landing on the empty square just beyond.',
        },
        chain: {
          title: 'Chain Captures',
          body: 'If another capture is available from the landing square, the chain continues in the same turn. A man that reaches the king row mid-chain promotes, but the chain ends there.',
        },
        ending: {
          title: 'Ending',
          body: 'You win by capturing every opponent piece or by leaving them with no legal move. A draw is declared after 40 consecutive king-only moves with no capture or man advance.',
        },
      },
    },
  },
  game: {
    banner: {
      turn: "{{player}}'s turn",
      youWin: 'You win!',
      youLose: 'You lose',
      whiteWins: 'White wins',
      blackWins: 'Black wins',
      draw: 'Draw',
    },
    pingOpponent: 'Ping opponent',
  },
  online: {
    create: {
      title: 'Create room',
      codeLabel: 'Room code',
      share: 'Share this code with your opponent',
      variantLabel: 'Playing {{variant}}',
      create: 'Create room',
    },
    share: {
      copyCode: 'Copy code',
      copyLink: 'Copy link',
      copied: 'Copied!',
    },
    identity: {
      verifiedName: '{{name}} ✓',
    },
    join: {
      title: 'Join room',
      codeLabel: 'Enter the room code',
      typeHint: 'Type the 4-character code',
      enterHint: 'Press Enter to join',
      submit: 'Join',
      variantLabel: 'Room is playing {{variant}}',
      paste: 'Paste',
    },
    status: {
      connecting: 'Connecting',
      creating: 'Creating room',
      waitingForOpponent: 'Waiting for opponent',
      opponentJoined: 'Opponent joined',
      joining: 'Joining',
      couldNotJoin: 'Could not join',
      error: 'Connection error',
    },
    overlay: {
      opponentDisconnected: '{{name}} disconnected',
      waitingForReconnection: 'Waiting for reconnection {{countdown}}',
      reconnecting: 'Reconnecting',
      restoringGame: 'Restoring game {{countdown}}',
      connectionLost: 'Connection lost',
      gameEnded: 'The game has ended',
      rematchOffered: 'Rematch offered',
      waitingForOpponent: 'Waiting for {{name}}',
      rematchRequested: '{{name}} wants a rematch',
      rematchDeclined: '{{name}} declined the rematch',
      gameOverWin: 'You win!',
      gameOverLoss: 'You lose',
      gameOverDraw: 'Draw',
      gameOverPrompt: 'Play again?',
      buttons: {
        leave: 'Leave',
        rematch: 'Rematch',
        returnToMenu: 'Menu',
        cancel: 'Cancel',
        accept: 'Accept',
        decline: 'Decline',
      },
    },
    resumeModal: {
      reconnectingTitle: 'Reconnecting…',
      reconnectingBody: 'Reconnecting to your game…',
      seatTakenTitle: 'Seat taken',
      seatTakenBody: 'That seat belongs to another account. Sign in with that account, or start a new game.',
      roomGoneTitle: 'Table closed',
      roomGoneBody: 'This game is over — the table has closed.',
      roomFullTitle: 'Room full',
      roomFullBody: 'Every seat at this table is taken, and none of them is yours.',
      anonymousTitle: "We can't confirm this seat is yours",
      anonymousBody: 'This browser has no record of the game. Sign in before your next online game and your seat follows you to any device.',
      unreachableTitle: "Couldn't reach the server",
      unreachableBody: "The server didn't answer. Check your connection and try again.",
      signIn: 'Sign in',
      viewSaved: 'View saved position',
      retry: 'Try again',
      discard: 'Discard',
    },
  },
  historyList: {
    title: 'Game history',
    empty: 'No saved games yet — play to start filling this list.',
    vsTemplate: '{{white}} vs {{black}}',
    winnerTemplate: '{{name}} wins',
    draw: 'Draw',
    unfinished: 'Unfinished',
    movesCount: '{{count}} moves',
    deleteAria: 'Delete this game',
    deleteConfirm: 'Delete this saved game?',
    downloadAria: 'Download game logs',
    modes: {
      ai: 'vs Bot',
      local: 'Local',
      online: 'Online',
    },
    accountSection: {
      title: 'Your account',
      loading: 'Loading…',
      empty: 'No online matches recorded yet.',
      statsLine: '{{wins}}W – {{losses}}L – {{draws}}D ({{played}} played)',
    },
    deviceSection: {
      title: 'On this device',
    },
  },
  replay: {
    controls: {
      first: 'First',
      previous: 'Previous',
      play: 'Play',
      pause: 'Pause',
      next: 'Next',
      last: 'Last',
      speed: 'Speed',
      backToHistory: 'Back to history',
      backToMenu: 'Back to menu',
    },
  },
  pwa: {
    updateAvailable: {
      title: 'Update available',
      body: 'A new version of Checkers is ready. Refresh to load it.',
      refresh: 'Refresh',
      later: 'Later',
    },
  },
};
